import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthProvider } from 'src/app/services/shared/autorizacion';

@Injectable({
  providedIn: 'root'
})
export class UsuarioGuard implements CanLoad {

  constructor(
    private usuario: AuthProvider
  ) {
  }
  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    // return true;
    return this.usuario.validaToken();
  }
}
